import React, { Fragment, useState, useEffect } from "react";
import { Button } from "antd";
import { KEYS } from "../../../../Config/Keys";
import { error, success } from "../../../../common/Alerts/Message";
import Swal from "sweetalert2";
import EditModalCard from "./EditModalCard";
import FadeInImage from "../../../../common/Images/FadeInImage";

import { CancelOrDeletePanelRequest } from "../../../../Config/API/panel";
import Loader from "../../../../common/cards/Loader";
import { useNavigate } from "react-router-dom";
import { fallbackprofile } from "../../../../common/Utils";
import useVariables from "../../../../common/hooks/useVariables";

const ActiveCard = ({ panel, setpanel, memberParent, status, object, isAdmin }) => {
  const [open, setopen] = useState(false);

  const [loading, setloading] = useState(false);
  const { viewer } = useVariables();
  const id = viewer?.id;

  const [person, setperson] = useState(panel?.organizer?._id === id); //current user id

  const cancelRequest = async () => {
    if (panel?._id && memberParent) {
      Swal.fire({
        icon: "warning",
        text: `Are you sure you want to Remove ${panel?.organizer?.name}!`,
        showCancelButton: true,
        cancelButtonColor: "var(--red)",
        confirmButtonText: "Remove Member"
      }).then(async (e) => {
        if (e.isConfirmed) {
          try {
            setloading(true);
            const response = await CancelOrDeletePanelRequest({
              id: panel.organizer?._id,
              panelId: memberParent,
              flag: "delete"
            });
            const dataa = await response.json();
            console.log(dataa);
            if (dataa.type === "success") {
              success("Member Removed!");
              dataa?.data?.members?.unshift(object);
              setpanel({ ...dataa.data });
            } else {
              error(dataa?.result);
            }
            setloading(false);
          } catch (e) {
            setloading(false);
            console.log(e);
            error("An error occured");
          }
        }
      });
    } else {
      error("no Member id found! try again later");
    }
  };
  useEffect(() => {
    return () => {
      setopen(null);
      setperson(null);
    };
  }, []);
  const navigate = useNavigate();

  return (
    <Fragment>
      {loading && <Loader fullpage loading="white" text="please wait removing member...!" />}
      <div className="membercard">
        <div
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(`/view/organizer/${panel?.organizer?._id}/timeline`, { state: "organizer" })
          }>
          <div className="popadd">
            <FadeInImage
              className="poprofilepic"
              type={"Fadegcard"}
              src={KEYS.API + "/" + panel?.organizer?.profilepic}
              fallaback={fallbackprofile}
            />
          </div>

          <p className="namepo">
            {panel?.organizer?.name + " " + (person ? "(You)" : "") || "dummy name"}
          </p>
          <p
            style={{
              color: "#7D7C7C",
              textAlign: "center",
              fontSize: "12px",
              marginTop: "8px"
            }}>
            {panel?.role || "No Role Assigned"}
          </p>
        </div>

        {!panel?.owner && (
          <Fragment>
            {status ? (
              <div className="pobuttons">
                <Button className="rejpo" type="primary" onClick={cancelRequest}>
                  <img
                    alt=""
                    style={{ margin: "-5px 8px 0px 0px" }}
                    src="/images/icons/delete.png"
                    height="14px"
                    width="12px"
                  />{" "}
                  Delete
                </Button>
                {/* only panel creator can change this */}
                {isAdmin && (
                  <Button onClick={() => setopen(true)} className="accpo" type="primary">
                    <img
                      alt=""
                      style={{ margin: "-5px 8px 0px 0px" }}
                      src="/images/icons/edit.png"
                      height="16px"
                      width="16px"
                    />
                    Edit{" "}
                  </Button>
                )}
              </div>
            ) : (
              <div style={{ minHeight: "15px" }} />
            )}
          </Fragment>
        )}
      </div>
      {open && (
        <EditModalCard
          r={panel?.role}
          open={open}
          setopen={setopen}
          organizerId={panel?.organizer?._id}
          setpanel={setpanel}
        />
      )}
    </Fragment>
  );
};

export default ActiveCard;
